import { Routes } from '@angular/router';
import { authGuard, authMatchGuard, loginRedirectGuard } from '@guards/auth-guard';

import { roleGuard } from '@guards/role.guard';
import { User } from '@models/user.model';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./pages/auth/auth.routes').then(m => m.routes),
  },
  {
    path: 'application/:uuid/success',
    loadComponent: () => import('./pages/application/success/success.component').then(m => m.SuccessComponent),
  },
  {
    path: 'application/:uuid/submit/:unitType',
    loadComponent: () => import('./pages/application/application-form/application-form.component').then(m => m.ApplicationFormComponent),
  },
  {
    path: 'application/:uuid/view/:applicationUuid',
    loadComponent: () => import('./pages/application/application-view/application-view.component').then(m => m.ApplicationViewComponent),
  },
  {
    path: 'application/:uuid/thanks/:applicationUuid',
    loadComponent: () => import('./pages/application/thank-you/thank-you.component').then(m => m.ThankYouComponent),
  },
  {
    path: 'not-found',
    loadComponent: () => import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent),
  },
  {
    path: 'server-error',
    loadComponent: () => import('./pages/server-error/server-error.component').then(m => m.ServerErrorComponent),
  },
  {
    path: '',
    canActivate: [authGuard],
    canMatch: [authMatchGuard, roleGuard([User.ROLE_ADMIN])],
    loadChildren: () => import('./pages/admin/admin.routes').then(m => m.routes),
  },
  {
    path: '',
    canActivate: [authGuard],
    canMatch: [authMatchGuard, roleGuard([User.ROLE_INSTANCE_CONFIGURATOR])],
    loadChildren: () => import('./pages/admin/instance-configurator.routes').then(m => m.routes),
  },
  {
    path: '',
    canActivate: [authGuard],
    canMatch: [authMatchGuard, roleGuard([User.ROLE_CLIENT_ADMIN])],
    loadChildren: () => import('./pages/admin/client-admin.routes').then(m => m.routes),
  },
  {
    path: '',
    canActivate: [authGuard],
    canMatch: [authMatchGuard, roleGuard([User.ROLE_MARKETER])],
    loadChildren: () => import('./pages/admin/marketer.routes').then(m => m.routes),
  },
  {
    path: '',
    canActivate: [authGuard],
    canMatch: [authMatchGuard, roleGuard([User.ROLE_PROPERTY_MANAGER])],
    loadChildren: () => import('./pages/admin/property-manager.routes').then(m => m.routes),
  },
  {
    path: 'forbidden',
    loadComponent: () => import('./pages/forbidden/forbidden.component').then(m => m.ForbiddenComponent),
  },
  {
    path: '**',
    canActivate: [loginRedirectGuard],
    loadComponent: () => import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent),
  },
];
